module.exports = __webpack_public_path__ + "static/img/liandong.fc9d3df.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/white/liandong.png
// module id = peA1
// module chunks = 24